export default __webpack_public_path__ + "static/media/meet7seat.4fdb5787.svg";